import Sortable from "../vendor/sortable.esm"
import { showBackofficeFlash } from "packs/init-backoffice-flashes"

const csrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

const patchReorder = async (grid, ids) => {
  const url = grid.dataset.reorderUrl
  if (!url || ids.length === 0) return true

  const body = new FormData()
  ids.forEach((id) => body.append("photo_ids[]", id))
  body.append("_method", "patch")

  const response = await fetch(url, {
    method: "POST",
    body,
    headers: {
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-Token": csrfToken() || "",
    },
    credentials: "same-origin",
  })

  return response.ok
}

const bindPhotosSortable = (grid) => {
  if (!grid || grid.dataset.sortableBound === "true") return
  grid.dataset.sortableBound = "true"

  Sortable.create(grid, {
    animation: 150,
    handle: "[data-content-photo-handle]",
    draggable: "[data-content-photo]",
    ghostClass: "is-dragging",
    forceFallback: true,
    fallbackOnBody: true,
    swapThreshold: 0.65,
    onEnd: async () => {
      const ids = Array.from(grid.querySelectorAll("[data-content-photo]"))
        .map((item) => item.dataset.contentPhotoId)
        .filter(Boolean)
      const ok = await patchReorder(grid, ids)
      if (!ok) showBackofficeFlash("Impossible de réordonner les photos", "alert")
    },
  })
}

export const initBackofficeContentPhotos = () => {
  document.querySelectorAll("[data-content-photos]").forEach(bindPhotosSortable)
}
